import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    const isMobileWorkspace = window.location.pathname.startsWith('/mobile');

    if (isMobileWorkspace) {
      navigator.serviceWorker.register('/service-worker.js').catch(() => {});
      return;
    }

    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((reg) => reg.unregister()));
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.filter((key) => key.startsWith('dealider-seller-pwa-')).map((key) => caches.delete(key)));
      }
    } catch {
      // no-op
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
